import { LookupHandler, LookupResultDetails } from "../ds/lookup_ds.js";
import {
  isEmpty,
  isEmptyArray,
  isEmptyString,
} from "../gui_components/Util.js";
export class CreditCardLookupHandler extends LookupHandler {
  constructor(lookup_data, attribute_name, type) {
    super();
    this.lookupdata = lookup_data;
    this.attribute_name = attribute_name;
    this.type = type;
    this.lookupTitle = attribute_name + " Lookup";
    let lookupDataCallback = function (lookup_dialog, page_number, filterText) {
      this.fetchDataFromService(lookup_dialog, page_number, filterText);
    };
    this.setDetails(lookupDataCallback, null, null);
    this.initColumns();
  }
  //function LookupDataColumn(columnDisplayName,columnBindingPropertyName,columnAlignment,valueColumn) {
  initColumns() {
     this.addColumnDefinition(this.attribute_name, "cardID", 0, true); //1
    this.addColumnDefinition("CardNumber", "cardNumber", 1, false); //1
    this.addColumnDefinition(
      "Expir Month",
      "expiryMonth",
      1,
      false
    ); //1
    this.addColumnDefinition(
      "Expiry Year",
      "expiryYear",
      1,
      false
    );
    this.addColumnDefinition(
      "CardType",
       "cardType",
      0,
      false
    );
    this.addColumnDefinition(
      "FirstName",
      "cardHolderFirstName",
      0,
      false
    );
    this.addColumnDefinition(
      "FirstName",
      "cardHolderLastName",
      0,
      false
    );
   

  }
  fetchDataFromService(lookup_dialog, pageNumber, filterText) {
    if (lookup_dialog !== null) {
      let lookup_result_details = new LookupResultDetails();
      lookup_result_details.pageData = this.lookupdata;
      let total_count = 0;
      if (this.lookupdata != null) {
        total_count = this.lookupdata.length;
      }
      lookup_result_details.totalRecordsCount = total_count;
      lookup_result_details.currentPageNumber = 1;
      lookup_result_details.pageSize = total_count;
      lookup_result_details.criteriaDisplayString = filterText;
      lookup_result_details.isGenericLookup = true;
      lookup_dialog.updateResultCallBack(lookup_result_details);
    }
  }
}
